export const SIGNUP_ROUTE = '/signup';
export const VERIFICATION_ROUTE = '/verification';
export const FORGOT_PASSWORD_ROUTE = '/forgot-password';
export const NEW_PASSWORD_ROUTE = '/new-password';
